import app from 'flarum/common/app';
import Link from 'flarum/common/components/Link';
import Icon from 'flarum/common/components/Icon';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import extractText from 'flarum/common/utils/extractText';
import Widget from 'ext:fof/forum-widgets-core/common/components/Widget';
const KEY = 'swtorpolska-popular-tags';

/**
 * Tagi do pokazania: widoczne, z dyskusjami, posortowane od najpopularniejszego.
 */
export function popularTags() {
  const limit = app.forum.attribute(`${KEY}.limit`) || 20;
  const includePrimary = app.forum.attribute(`${KEY}.includePrimary`) !== false;
  const minDiscussions = app.forum.attribute(`${KEY}.minDiscussions`) ?? 1;
  return app.store.all('tags').filter(tag => !tag.isHidden?.()).filter(tag => includePrimary || tag.position() === null).filter(tag => (tag.discussionCount() || 0) >= minDiscussions).sort((a, b) => (b.discussionCount() || 0) - (a.discussionCount() || 0)).slice(0, limit);
}
export default class PopularTagsWidget extends Widget {
  oninit(vnode) {
    super.oninit(vnode);
    this.attrs.state.loading ??= false;
    this.attrs.state.loaded ??= false;
  }
  oncreate(vnode) {
    super.oncreate(vnode);

    // Strona forum ładuje tylko część tagów — dociągamy pełną listę raz.
    if (!this.attrs.state.loaded && !this.attrs.state.loading) {
      this.attrs.state.loading = true;

      // [swtor-polska.pl] zapytanie w tle: przy błędzie widżet pokazuje tagi, które już są,
      // bez czerwonego komunikatu „Ups! Coś poszło nie tak”.
      app.store.find('tags', {}, {}, {
        background: true,
        errorHandler: () => {}
      }).catch(() => null).then(() => {
        this.attrs.state.loading = false;
        this.attrs.state.loaded = true;
        m.redraw();
      });
    }
  }
  className() {
    return 'PopularTagsWidget';
  }
  icon() {
    return 'fas fa-tags';
  }
  title() {
    return extractText(app.translator.trans(`${KEY}.forum.widget.title`));
  }
  content() {
    const tags = popularTags();
    if (!tags.length) {
      return this.attrs.state.loading ? m(LoadingIndicator, {
        size: "small",
        display: "block"
      }) : m("p", {
        className: "PopularTagsWidget-empty"
      }, app.translator.trans(`${KEY}.forum.widget.empty`));
    }
    const showCounts = app.forum.attribute(`${KEY}.showCounts`) !== false;
    const counts = tags.map(t => t.discussionCount() || 0);
    const max = Math.max(...counts);
    const min = Math.min(...counts);

    // 5 rozmiarów chmury: 1 (najmniej dyskusji) … 5 (najwięcej)
    const level = count => max === min ? 3 : 1 + Math.round((count - min) / (max - min) * 4);
    return m("div", {
      className: "PopularTagsWidget-cloud"
    }, tags.map(tag => {
      const count = tag.discussionCount() || 0;
      const color = tag.color();
      return m(Link, {
        href: app.route('tag', {
          tags: tag.slug()
        }),
        className: `PopularTagsWidget-tag PopularTagsWidget-tag--${level(count)}${color ? ' PopularTagsWidget-tag--colored' : ''}`,
        style: color ? {
          '--tag-color': color
        } : undefined,
        title: extractText(app.translator.trans(`${KEY}.forum.widget.discussions`, {
          count
        }))
      }, tag.icon() ? m(Icon, {
        name: tag.icon(),
        className: "PopularTagsWidget-tag-icon"
      }) : null, m("span", {
        className: "PopularTagsWidget-tag-name"
      }, tag.name()), showCounts ? m("span", {
        className: "PopularTagsWidget-tag-count"
      }, count) : null);
    }));
  }
}
flarum.reg.add('swtorpolska-popular-tags', 'common/components/PopularTagsWidget', PopularTagsWidget);